import { Under } from "../styles/basicStyles";

function Undermsg() {
  return (
    <>
      <Under>HUFS GLOBAL LIKELION</Under>
    </>
  );
}

export default Undermsg;
